import React from 'react';
import { colors } from '@styleseat/brand';

type ShoppingBusinessIconProps = {
  width?: number;
  height?: number;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const ShoppingBusinessIcon = ({
  width = 12,
  height = 11,
  color = colors.blackInBlack,
}: ShoppingBusinessIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9406 3.53514L11.3104 0.912294C11.1784 0.37212 10.7102 0 10.1641 0H1.82737C1.2872 0 0.813043 0.378122 0.687002 0.912294L0.0567996 3.53514C-0.0872468 4.14733 0.0447958 4.77154 0.428919 5.26369C0.476935 5.32972 0.542956 5.37773 0.596973 5.43775V9.60309C0.596973 10.2633 1.13715 10.8035 1.79736 10.8035H10.2001C10.8603 10.8035 11.4005 10.2633 11.4005 9.60309V5.43775C11.4545 5.38373 11.5205 5.32971 11.5685 5.2697C11.9526 4.77754 12.0907 4.14733 11.9406 3.53514ZM10.146 1.19438L10.7762 3.81723C10.8363 4.06931 10.7823 4.32139 10.6262 4.51945C10.5422 4.62749 10.3621 4.80155 10.062 4.80155C9.6959 4.80155 9.3778 4.50745 9.33578 4.11732L8.98767 1.20039L10.146 1.19438ZM6.59891 1.20039H7.77528L8.09939 3.91326C8.1294 4.14734 8.05737 4.38141 7.90132 4.55547C7.76928 4.71152 7.57722 4.80155 7.33114 4.80155C6.92901 4.80155 6.59891 4.44743 6.59891 4.01529V1.20039ZM3.89203 3.91326L4.22214 1.20039H5.39852V4.01529C5.39852 4.44743 5.06841 4.80155 4.62427 4.80155C4.4202 4.80155 4.23414 4.71152 4.0901 4.55547C3.94005 4.38141 3.86803 4.14734 3.89203 3.91326ZM1.22117 3.81723L1.82737 1.20039H3.00975L2.66164 4.11732C2.61362 4.50745 2.30152 4.80155 1.9354 4.80155C1.64131 4.80155 1.45525 4.62749 1.37722 4.51945C1.21517 4.32739 1.16115 4.06931 1.22117 3.81723ZM1.79736 9.60309V5.98393C1.84538 5.98993 1.88739 6.00193 1.9354 6.00193C2.45757 6.00193 2.93172 5.78586 3.27984 5.43175C3.63995 5.79186 4.12011 6.00193 4.66628 6.00193C5.18845 6.00193 5.6566 5.78586 6.00471 5.44375C6.35883 5.78586 6.83898 6.00193 7.37916 6.00193C7.88332 6.00193 8.36347 5.79186 8.72359 5.43175C9.0717 5.78586 9.54585 6.00193 10.068 6.00193C10.116 6.00193 10.1581 5.98993 10.2061 5.98393V9.60309H1.79736Z"
      fill={color}
    />
  </svg>
);
